import { ColumnRank, ColumnStartOrder, ColumnBib, ColumnName, ColumnWarnings, ColumnNoc, ColumnRecords, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import { findArray, RscFromStore } from 'helpers/utils'
import Label from "components/general/Label"
import SportCode from 'components/common/SportCode'
import { getRscObject } from 'helpers/rsc';

function getCell(row, attempt) {
    let cell = null

    if (!!row) {
        let bestAttemp = row?.extendedResults && findArray(row.extendedResults, { er_code: ['BEST_ATTEMPT_NUM'] }).er_value
        let intNode = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [attempt.toString()] })
        let value = intNode?.er_value
        let wind = findArray(intNode.extensions, { ere_code: ['WIND_SPEED'] })?.ere_value
        cell = <><div className={attempt == bestAttemp ? 'fw-bold text-success' : ''}>{value}</div> <div className="fst-italic">{wind}</div></>
    }
    return cell
}

function getResult(result, wind){
    return (
        <><div>{result}</div> <div className="fst-italic">{wind}</div></>
    )
}

export function ColumnResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10 ',
    label = 'HeaderResult',
    remove = false,
    hideIrm = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,

            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let rowNumberIrm = findArray(props.cell.row.original.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value || ''
                let resultIrm = (props.cell.row.original.resultIrm)

                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} /></>
                        break;
                    default:
                        irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} related={resultIrm} />
                        break;
                }
                irmObject = hideIrm ? <></> : irmObject;
                let windSpeed = findArray(props.cell.row.original?.extendedResults, {er_code: ['WIND_SPEED']})?.er_value
                return (
                    props.cell.row.original.resultType === 'IRM'
                        ? irmObject
                        : windSpeed ? getResult(props.cell.row.original.resultData, windSpeed): props.cell.row.original.resultData
                )
            },
        }
    )
}

export function TableColumns(columnsAdded) {
    let numCols = findArray(columnsAdded, { ei_code: ['INTERMEDIATES_TOTAL'] }).ei_value

    let columnsExt = []
    for (let i = 0; i < numCols; i++) {
        let attempt = i + 1;
        columnsExt.push(
            {
                Header: attempt,
                accessor: (props) => (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [attempt.toString()] }).er_value
                        : ''
                ),
                Cell: (props) => (
                    getCell(props.cell.row.original, attempt)
                ),
                id: 'Attempts' + attempt,
                className: 'result',
                headerClassName: 'text-center w-5'

            },
        )
    }

    return (
        [
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Rank',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderRank',
                columns: [ColumnRank({ remove: true }),]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'StartOrder',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderStartOrder',
                columns: [{
                    Header: <Label data={'HeaderOrder'} />,
                    className: 'text-end',
                    headerClassName: 'text-end w-5',
                    disableSortBy: true,
                    id: 'StartOrder',
                    remove: true,
                    accessor: (props) => {
                        let orderCurrent = findArray(props?.extendedResults, { er_code: ['ORDER_CURRENT'] })?.er_value
                        return orderCurrent ? orderCurrent : props?.startSortOrder
                    },
                    Cell: (props) => {
                        let orderCurrent = findArray(props?.cell?.row?.original?.extendedResults, { er_code: ['ORDER_CURRENT'] })?.er_value
                        return orderCurrent ? orderCurrent : props?.cell?.row?.original?.startOrder
                    }
                },]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Bib',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderBib',
                columns: [ColumnBib({ remove: true }),]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'NOC',
                headerClassName: "text-start d-none d-md-table-cell w-5 align-middle",
                id: 'HeaderNOC',
                columns: [ColumnNoc({ remove: true }),]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Name',
                headerClassName: "text-start  align-middle",
                id: 'HeaderName',
                columns: [ColumnName({ remove: true }),]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Warnings',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderWarnings',
                columns: [ColumnWarnings({ remove: true }),]
            },
            {
                id: 'HeaderAttempts',
                Header: <Label data="HeaderAttempts" />,
                headerClassName: "text-center",
                columns: [...columnsExt]
            },

            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Result',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderResult',
                columns: [ColumnResult({ label: 'HeaderBest', remove: true }),]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Records',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderRecords',
                columns: [ColumnRecords({ remove: true }),]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'QualMark',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderQualMark',
                columns: [ColumnQualification({ remove: true }),]
            },

        ]
    )
}


export default TableColumns
